import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import {
  getSafeRedirectPath,
  IMPERSONATE_ID_PARAM_NAME,
  REDIRECT_URL_PARAM_NAME,
} from '@repo/utils/portalImpersonation';
import { hydrateReduxSessionState } from 'services/auth/hydrateReduxSessionState';
import { useAppDispatch } from 'store/store';
import {
  deleteImpersonationCookie,
  setImpersonationCookie,
} from 'utils/impersonation';
import { getJWTToken } from 'utils/jwt';

export default function ImpersonateRoute() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const impersonateId =
      searchParams.get(IMPERSONATE_ID_PARAM_NAME) ?? undefined;
    const redirectUrl = getSafeRedirectPath(
      searchParams.get(REDIRECT_URL_PARAM_NAME) ?? undefined,
    );

    if (!impersonateId) {
      navigate('/', { replace: true });
      return;
    }

    deleteImpersonationCookie({ scope: 'global' });
    setImpersonationCookie(impersonateId, { scope: 'host-only' });

    hydrateReduxSessionState({ dispatch, token: getJWTToken(), impersonateId });

    navigate(redirectUrl || '/results', { replace: true });
  }, [dispatch, navigate, searchParams]);

  return null;
}
